import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { withRouter } from 'react-router-dom';

import {
  Menu,
  MenuItem,
  Drawer,
  IconButton as MuiIconButton,
} from "@material-ui/core";

import { AccountCircleOutlined } from "@material-ui/icons";

// import { removeUserStore } from "./../models/index"
import LocalStorageService from "./../services/LocalStorageService";
import ChangePassword from "./ChangePassword";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 35px;
    height: 35px;
  }
`;

const localStorageService = LocalStorageService.getService();

class UserMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorMenu: null
    };
  }

  toggleMenu = event => {
    this.setState({ anchorMenu: event.currentTarget });
  };

  closeMenu = (action) => {
    this.setState({ anchorMenu: null });
    if (action === 'signOut') {
      localStorageService.clearToken()
      localStorageService.clearUserInfor()
      this.props.history.push('/auth/sign-in')
    }

  };

  toggleDrawer = (open) => {
    // this.closeMenu('');
    this.setState({ isOpen: open });
  };

  render() {
    const { anchorMenu } = this.state;
    const open = Boolean(anchorMenu);

    return (
      <React.Fragment>
        <IconButton
          aria-owns={open ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={this.toggleMenu}
          color="inherit"
        >
          <AccountCircleOutlined />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorMenu}
          open={open}
          onClose={() => this.closeMenu()}
        >
          <MenuItem
            onClick={() => this.toggleDrawer(true)}
          >
            Đổi mật khẩu
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.closeMenu('signOut');
            }}
          >
            Đăng xuất
          </MenuItem>
          <Drawer anchor="right" open={this.state.isOpen} onClose={() => this.toggleDrawer(false)}>
            <ChangePassword />
          </Drawer>
        </Menu>
        {/* <ChangePassword ></ChangePassword> */}
      </React.Fragment>
    );
  }
}

export default withRouter(withTheme(UserMenu));